import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import itAppStrings from 'Translations/lang-it.json';
import enAppStrings from 'Translations/lang-en.json';
// import { getData } from 'Api/home/home';
import LanguageProvider from 'Utility/LanguageProvider';
import ErrorBoundary from 'Utility/ErrorBoundary';
import LakaWallet2_0Container from './LakaWallet_2_0Container';
import { axiosInstance as axios } from 'Api';
import theme from '../styles/themes/theme';
import '../styles/scss/main.scss';
import '../styles/scss/icons.scss';

const themes = createTheme(theme);

const translationMessages = {
	it: {
		...itAppStrings,
	},
	en: {
		...enAppStrings,
	},
};

export const LanguageContext = React.createContext();

class MainContainer extends Component {
	static propTypes = {
		authRoutes: PropTypes.objectOf(
			PropTypes.arrayOf(
				PropTypes.shape({
					component: PropTypes.func.isRequired,
					routeName: PropTypes.string.isRequired,
				})
			)
		).isRequired,
		noauthRoutes: PropTypes.objectOf(
			PropTypes.arrayOf(
				PropTypes.shape({
					component: PropTypes.func.isRequired,
				})
			)
		).isRequired,
		store: PropTypes.object.isRequired,
		logged: PropTypes.bool.isRequired,
	};

	state = {
		language: {
			messages: translationMessages,
			locale: 'it',
		},
		permissions: [],
		loading: true,
	};

	fetchPermissions = async () => {
		try {
			const response = await axios.post('config/getFunctionRoleMapList');
			const { functionRoleMapList } = response.data;
			this.setState({
				permissions: [...functionRoleMapList.map((item) => item.function), 'Home'],
				loading: false,
			});
		} catch (error) {
			console.error('Error fetching permissions:', error);
			this.setState({ loading: false });
		}
	};

	componentDidMount() {
		if (this.props.logged) {
			if (ISMOCK) {
				this.setState({
					permissions: [
						'Promotions',
						'Account',
						'CustomerCare',
						'ElectronicPurse',
						'Groups',
						'Merchant',
						'Payment',
						'Register',
						'Store',
						'Transactions',
						'Users',
						'Home',
					],
					loading: false,
				});
			} else {
				this.fetchPermissions();
			}
		} else {
			this.setState({ loading: false });
		}
	}

	changeLanguage = (lang) => {
		this.setState({
			language: {
				messages: {
					[lang]: {
						...(lang === 'en' ? enAppStrings : itAppStrings),
					},
				},
				locale: lang,
			},
		});
	};

	render() {
		const { store, logged } = this.props;

		return (
			<>
				<Provider store={store}>
					<LanguageProvider language={this.state.language}>
						<ThemeProvider theme={themes}>
							<ErrorBoundary>
								<LanguageContext.Provider
									value={{
										language: this.state.language.locale,
										changeLanguage: this.changeLanguage,
									}}>
									<LakaWallet2_0Container logged={logged} permittedRoutes={this.state.permissions} {...this.props} />
								</LanguageContext.Provider>
							</ErrorBoundary>
						</ThemeProvider>
					</LanguageProvider>
				</Provider>
			</>
		);
	}
}

export default MainContainer;
